import { useEffect } from "react";

const IS_DEV_AUTH = import.meta.env.VITE_USE_DEV_AUTH === "true";

export default function Login() {
  useEffect(() => {
    if (IS_DEV_AUTH) {
      window.location.href = "/";
      return;
    }

    const hash = window.location.hash || "#/login";
    const query = hash.includes("?") ? hash.split("?")[1] : "";
    const params = new URLSearchParams(query);
    const returnTo = params.get("returnTo");
    let redirectTarget = window.location.origin;

    if (returnTo) {
      const candidate = new URL(returnTo, window.location.origin);
      if (candidate.origin === window.location.origin) {
        redirectTarget = candidate.toString();
      }
    }

    const loginUrl = `https://yakizakana.net/login?redirect=${encodeURIComponent(redirectTarget)}`;
    window.location.href = loginUrl;
  }, []);

  return null;
}
